<template>
    <!-- 右边主体[[ -->
    <div class="g-content g-autofixheight profit">

        <div id="profit-top-con">
            <ul class="ptc-profit">
                <li class="ptc-total-revenue ptc-profit-con">
                    <p class="profit-tit">总收益（自由、订单、活动）</p>
                    <p class="profit-num">
                        <span class="money-icon">&yen;</span>
                        <span class="money-num f-hide-col-1" >{{data.profitView.historyIncome}}</span>
                    </p>
                    <p class="total-revenue-num f-hide-col-1">尚未到账：&yen;{{data.profitView.inCome}}</p>
                </li>
                <li class="recent-earnings ptc-profit-con">
                    <p class="profit-tit">昨日收益</p>
                    <p class="profit-num">
                        <span class="money-icon">&yen;</span>
                        <span class="money-num">{{data.profitView.yesterdayIncome}}</span>
                    </p>
                    <p class="total-revenue-num"></p>
                </li>
                <li class="profit-account ptc-profit-con">
                    <p class="profit-tit">到账总收益（已支付至QQ钱包）</p>
                    <p class="profit-num">
                        <span class="money-icon">&yen;</span>
                        <span class="money-num">{{data.profitView.accountIncome}}</span>
                    </p>
                    <p class="total-revenue-num">代缴税费：&yen;{{data.profitView.tax}}</p>
                </li>
            </ul>
            <div class="g-tab profit-tab">
                <a href="javascript:;">
                    <div class="g-tab-item" v-bind:class="{'g-tab-item-active':data.flow}" @click="flowClick()">自由投稿收益</div>
                </a>
                <a href="javascript:;">
                    <div class="g-tab-item" v-bind:class="{'g-tab-item-active':data.order}" @click="orderClick()">订单收益</div>
                </a>
                <a href="javascript:;">
                    <div class="g-tab-item" v-bind:class="{'g-tab-item-active':data.mission}" @click="missionClick()">活动收益</div>
                </a>
            </div>
        </div>

        <flow-reward v-if="data.flow" ></flow-reward>
        <order-profit v-if="data.order" ></order-profit>
        <mission-profit v-if="data.mission"></mission-profit>
    </div>
    <!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import '~Assets/sass/pages/v4/profit/profit.scss';
</style>
<script>

import flowReward from './flow-reward.vue';
import orderProfit from './order-profit.vue';
import missionProfit from './mission-profit.vue';
import {
    incomeOverview
} from 'Services/getData.js';
export default {
    data() {
        return {
            data: {
                flow: true,
                order: false,
                mission: false,
                profitView: {
                    inCome: 0, // 总收益(结算中)
                    historyIncome: 0,  //累计总收益
                    newIncome: 0,  //最近收益(结算中)
                    payDate: '',  //最近收益时间
                    accountIncome: 0, //到账总收益(已支付至qq钱包)
                    tax: 0  //代缴税费
                }
            }
        }
    },
    components: {
        flowReward, orderProfit, missionProfit
    },
    mounted(){
        this.getIncomeInfo();
    },
    methods: {
        flowClick(){
            this.data.flow = true;
            this.data.order = false;
            this.data.mission = false;
        },
        orderClick(){
            this.data.flow = false;
            this.data.order = true;
            this.data.mission = false;
        },
        missionClick(){
            this.data.flow = false;
            this.data.order = false;
            this.data.mission = true;
        },
        async getIncomeInfo() {
            let ret = await incomeOverview();
            if(ret.data && ret.data.code == 0){
                this.data.profitView = ret.data.data;
            }
        }
    }
}
</script>
